import { NgModule } from '@angular/core';
import { ClassCalendarDay } from './class-calendar-day/printdate.pipe';
import { PrintDate } from './print-date/print-date.pipe';
import { PrintNumber } from './number/number.indra.pipe';
import { INDRAPrintFormattedDate } from './print-date/print-formatted-date.indra.pipe';
import { INDRACurrencyPipe } from '@ibe.services/currency.indra.pipe';
import { INDRAFormatNumberToLocalePipe } from '@ibe.services/format-number.indra.pipe';

@NgModule({
	declarations: [PrintDate, ClassCalendarDay, PrintNumber, INDRAPrintFormattedDate, INDRACurrencyPipe, INDRAFormatNumberToLocalePipe],
	imports: [],
	exports: [PrintDate, ClassCalendarDay, PrintNumber, INDRAPrintFormattedDate, INDRACurrencyPipe, INDRAFormatNumberToLocalePipe]
})
export class PipesModule {}
